/**
 * ProtectedRoute — gates every authenticated route.
 *
 * - No token / no user → redirect to ``/login?next=<currentPath>`` (AUTH-05 preserves target URL)
 * - ``user.password_must_rotate=true`` and pathname not ``/rotate-password`` → redirect to rotate
 *   (USR-04 client-side belt; backend's 428 from ``require_password_not_rotating`` is the brace)
 * - Otherwise renders the nested ``<Outlet />``
 */
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthStore } from "@/lib/auth";

export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const loc = useLocation();

  if (!token || !user) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // USR-04: forced password rotation. Don't loop on the rotate page itself.
  if (user.password_must_rotate && loc.pathname !== "/rotate-password") {
    return <Navigate to="/rotate-password" replace />;
  }

  return <Outlet />;
}
